import { render, staticRenderFns } from "./StockistRecord.vue?vue&type=template&id=2d6e1039&scoped=true"
import script from "./StockistRecord.vue?vue&type=script&lang=js"
export * from "./StockistRecord.vue?vue&type=script&lang=js"
import style0 from "./StockistRecord.vue?vue&type=style&index=0&id=2d6e1039&prod&scoped=true&lang=css"
import style1 from "./StockistRecord.vue?vue&type=style&index=1&id=2d6e1039&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e1039",
  null
  
)

export default component.exports